import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialInput from "../../components/MaterialInput";
import { Autocomplete, Box, Chip, TextField } from "@mui/material";
import {  EXPORT_BASE_URL, fetchAll, postItem } from "../../BaseUrl";
import {  GETCLIENT } from "../Masters/ClientMaster/Mutation";
import MaterialButton from "../../components/MaterialButton";
import colors from "../../assest/theme/base/colors";
import MessagePopup from "../Utils/MessagePopup";
import ConfirmDialog from "../Utils/ConfirmDialog";
import { Getalluserdetail } from "../Masters/UserMaster/mutation";
import { getallpostion } from "../Masters/PositionMaster/mutation";
import MaterialSelect from "../../components/MasterSelect";
import { EXPORTREPORTDATA } from "./Mutation";
import { downloadExcelFile } from "../Utils/DownloadExcel";
import AccessComponent from "../Utils/AccessComponent";

const statusoptions = [
  { label: "Shortlisted", value: "shortlisted" },
  { label: "Not Shortlisted", value: "not_shortlisted" },
  { label: "Interviewed", value: "interviewed" },
  { label: "Onboarded", value: "onboarded" },
];

const exportTypeoptions = [
  { label: "Excel", value: "csv" },
  { label: "CSV", value: "csv" },
];

function Reports() {
  const [reportData, setReportData] = useState({
    fromDate: "",
    toDate: "",
    client: "",
    positions: "",
    users: "",
    status: "",
    exportType: "",
    fromDateStatus: "unchecked",
    toDateStatus: "unchecked",
    clientStatus: "unchecked",
    positionsStatus: "unchecked",
    usersStatus: "unchecked",
    statusStatus: "unchecked",
    exportTypeStatus: "unchecked",
  });
  const [clientoptions, setclientoptions] = useState([]);
  const [positionsoptions, setPositionsoptions] = useState([]);
  const [useroptions, setUseroptions] = useState([]);
  const [positionsFIlteroptions, setPositionsFIlteroptions] = useState([]);
  const [userFIlteroptions, setUserFIlteroptions] = useState([]);
  const [searchdata, setsearchdata] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => {},
  });
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success", // 'success' or 'error'
  });

  useEffect(() => {
    getClientData();
    getUserData();
    getPositionData();
  }, []);

  useEffect(() => {
    if (reportData.client) {
      handleClientChange(reportData.client);
    }
  }, [reportData]);

  // const handleClientChange = (event, newValue) => {
  //   const selectedClientValues = newValue.map((option) => option.value);

  //   setReportData((prevData) => ({
  //     ...prevData,
  //     client: newValue,
  //     clientStatus: newValue.length > 0 ? "success" : "unchecked",
  //   }));

  //   // Filter positions based on selected clients
  //   const filteredPositions = positionsoptions.filter((position) =>
  //     selectedClientValues.includes(position.client)
  //   );
  //   setPositionsFIlteroptions(filteredPositions);

  //   // Filter users based on selected clients
  //   const filteredUsers = useroptions.filter((user) =>
  //     user.client.some((client) => selectedClientValues.includes(client))
  //   );
  //   setUserFIlteroptions(filteredUsers);
  // };

  const handleClientChange = (client) => {

    const selectedClientValue = client?.value || ""; // Extract the value from the selected client option.

    // Filter positions based on the selected client
    const filteredPositions = positionsoptions.filter(
      (position) => position.client === selectedClientValue
    );
    setPositionsFIlteroptions(filteredPositions);

    // Filter users based on the selected client
    const filteredUsers = useroptions.filter((user) =>
      user.client.includes(selectedClientValue)
    );
    setUserFIlteroptions(filteredUsers);
  };

  const handlePositionsChange = (event, newValue) => {
    setReportData((prevData) => ({
      ...prevData,
      positions: newValue,
      positionsStatus: newValue.length > 0 ? "success" : "unchecked",
    }));
  };

  const handleUsersChange = (event, newValue) => {
    setReportData((prevData) => ({
      ...prevData,
      users: newValue,
      usersStatus: newValue.length > 0 ? "success" : "unchecked",
    }));
  };

  const handleReportsChange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...reportData };
    if (event?.target === undefined && selectEvent) {
      if (
        selectEvent.name === "status" ||
        selectEvent.name === "exportType" ||
        selectEvent.name === "client"
      ) {
        const lengthRegex = new RegExp("^.{1,50}$");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "fromDate":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "toDate":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] = event.target.value;
      }
    }
    setReportData(formState);
  };

  const resetForm = () => {
    setReportData({
      fromDate: "",
      toDate: "",
      client: "",
      positions: "",
      users: "",
      status: "",
      exportType: "",
      fromDateStatus: "unchecked",
      toDateStatus: "unchecked",
      clientStatus: "unchecked",
      positionsStatus: "unchecked",
      usersStatus: "unchecked",
      statusStatus: "unchecked",
      exportTypeStatus: "unchecked",
    });
    handleCloseDialog();
  };
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const onSubmitOpen = () => {
    handleOpenDialog();
    setDialogData({
      title: `Export reports ?`,
      content: `Are you sure you want toExport reports ?`,
      onConfirm: () => handleSubmit(),
    });
  };

  const isFormValid = () => {
    return (
      reportData.fromDateStatus === "success" &&
      reportData.toDateStatus === "success" &&
      reportData.exportTypeStatus === "success"
    );
  };

  //   {
  //   "filters": {
  //     "hrUserIds": ["1", "2"],
  //     "positionIds": ["5", "8"],
  //     "clientId": "3",
  //     "status": "screeningqueue",
  //     "dateFrom": "2024-01-01",
  //     "dateTo": "2024-12-31",
  //     "exportType": "excel"
  //   }
  // }

  const handleSubmit = async () => {
    const variables = {
      dateFrom: reportData.fromDate,
      dateTo: reportData.toDate,
      clientId: reportData.client.value,
      positionIds: reportData.positions.map((position) => position.value), // Extracting `value` from positions
      hrUserIds: reportData.users.map((user) => user.value), // Extracting `value` from users
      status: reportData.status.value,
      exportType: reportData.exportType.value,
    };
    try {
      //post api call
      const response = await postItem(EXPORTREPORTDATA, { filters: variables });
      if (response?.exportScreeningData?.success === true) {
        const fullUrl = `${EXPORT_BASE_URL}${response?.exportScreeningData?.downloadUrl}`;
        const status = downloadExcelFile(fullUrl, "Reports");
        if (status === true) {
          setPopup({
            open: true,
            message: response?.exportScreeningData?.message,
            severity: "success",
          });
        } else {
          setPopup({
            open: true,
            message: "Export file failed",
            severity: "success",
          });
        }
      } else {
        setPopup({
          open: true,
          message: response?.exportScreeningData?.message,
          severity: "error",
        });
      }
    } catch (error) {
      console.error(error);
      setPopup({
        open: true,
        message: error,
        severity: "error",
      });
    } finally {
      resetForm();
    }
  };

  const getClientData = async () => {
    try {
      const response = await fetchAll(GETCLIENT);
      if (response?.getAllClients?.success === true) {
        const data = response?.getAllClients?.data.map((v, i) => ({
          value: v?.id,
          label: v?.clientName,
        }));
        setclientoptions(data);
      } else {
        setclientoptions([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const getUserData = async () => {
    try {
      const response = await fetchAll(Getalluserdetail);
      if (response?.getAllCustomUserDetails?.success) {
        const data = response?.getAllCustomUserDetails?.data.map((user) => ({
          value: user?.id,
          label: user?.username,
          client: user?.clientHandling?.map((client) => client?.id) || [],
        }));
        setUseroptions(data);
      } else {
        setUseroptions([]);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      // Any cleanup code can go here if needed
    }
  };

  const getPositionData = async () => {
    try {
      const response = await fetchAll(getallpostion);
      if (response?.getAllPositions?.success === true) {
        const data = response?.getAllPositions?.data.map((v, i) => ({
          value: v?.id,
          label: v?.positionName,
          client: v?.client?.id,
        }));
        setPositionsoptions(data);
      } else {
        setPositionsoptions([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  return (
    <DashboardLayout searchdata={searchdata} setsearchdata={setsearchdata}>
      <ConfirmDialog //confirmation pop component
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />
      <MessagePopup //error or succes pop component
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <Box p={5}>
        <Box sx={{ p: 6, backgroundColor: "#fff", borderRadius: "20px" }}>
          <p style={{ fontWeight: "bold" }}>Export Data</p>
          <Grid container spacing={4} p={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                From Date
                <span style={{ marginLeft: "2px", color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialInput
                name="fromDate"
                type="date"
                value={reportData.fromDate}
                onChange={handleReportsChange}
                error={reportData.fromDateStatus === "error" ? true : false}
                success={reportData.fromDateStatus === "success" ? true : false}
                inputProps={{
                  max: new Date().toISOString().split("T")[0], // max today
                }}
              />
              {reportData.fromDateStatus === "error" && (
                <MaterialTypography
                  variant="caption"
                  color="error"
                  sx={{ mt: 0.5, display: "block" }}
                >
                  From Date Should be DD-MM-YYYY.
                </MaterialTypography>
              )}
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                To Date
                <span style={{ marginLeft: "2px", color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialInput
                name="toDate"
                type="date"
                value={reportData.toDate}
                onChange={handleReportsChange}
                error={reportData.toDateStatus === "error" ? true : false}
                success={reportData.toDateStatus === "success" ? true : false}
                inputProps={{
                  max: new Date().toISOString().split("T")[0], // max today
                  min: reportData.fromDate || undefined, // min fromDate
                }}
              />
              {reportData.toDateStatus === "error" && (
                <MaterialTypography
                  variant="caption"
                  color="error"
                  sx={{ mt: 0.5, display: "block" }}
                >
                  To Date Should be DD-MM-YYYY.
                </MaterialTypography>
              )}
            </Grid>

            {/* <Grid size={{ xs: 12, md: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Client
                <span style={{ marginLeft: "2px", color: "red" }}>*</span>
              </MaterialTypography>
              <Autocomplete
                multiple
                id="conducted-select"
                options={clientoptions}
                getOptionLabel={(option) => option?.label || ""}
                value={reportData.client || []}
                onChange={handleClientChange}
                filterSelectedOptions
                renderTags={(selected, getTagProps) =>
                  selected.map((option, index) => (
                    <Chip
                      key={option.id}
                      label={option.label}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Clients" />
                )}
              />
            </Grid> */}

            <Grid size={{ xs: 12, md: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                sx={{ color: colors.inputlabel }}
              >
                Client
                {/* <span style={{ marginLeft: "2px", color: "red" }}>*</span> */}
              </MaterialTypography>
              <MaterialSelect
                name="client"
                placeholder={`Select Client`}
                value={reportData.client}
                options={clientoptions}
                searchable={false}
                onChange={handleReportsChange}
                error={reportData.clientStatus === "error" ? true : false}
                success={reportData.clientStatus === "success" ? true : false}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Positions
                {/* <span style={{ marginLeft: "2px", color: "red" }}>*</span> */}
              </MaterialTypography>
              <Autocomplete
                multiple
                id="conducted-select"
                options={positionsFIlteroptions}
                getOptionLabel={(option) => option?.label || ""}
                value={reportData.positions || []}
                onChange={handlePositionsChange}
                filterSelectedOptions
                renderTags={(selected, getTagProps) =>
                  selected.map((option, index) => (
                    <Chip
                      key={option.id}
                      label={option.label}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Positions" />
                )}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Users
                {/* <span style={{ marginLeft: "2px", color: "red" }}>*</span> */}
              </MaterialTypography>
              <Autocomplete
                multiple
                id="conducted-select"
                options={userFIlteroptions}
                getOptionLabel={(option) => option?.label || ""}
                value={reportData.users || []}
                onChange={handleUsersChange}
                filterSelectedOptions
                renderTags={(selected, getTagProps) =>
                  selected.map((option, index) => (
                    <Chip
                      key={option.id}
                      label={option.label}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Users" />
                )}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                sx={{ color: colors.inputlabel }}
              >
                Status
                {/* <span style={{ marginLeft: "2px", color: "red" }}>*</span> */}
              </MaterialTypography>
              <MaterialSelect
                name="status"
                placeholder={`Select Status`}
                value={reportData.status}
                options={statusoptions}
                searchable={false}
                onChange={handleReportsChange}
                error={reportData.statusStatus === "error" ? true : false}
                success={reportData.statusStatus === "success" ? true : false}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                sx={{ color: colors.inputlabel }}
              >
                Export Type
                <span style={{ marginLeft: "2px", color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialSelect
                name="exportType"
                placeholder={`Select Export Type`}
                value={reportData.exportType}
                options={exportTypeoptions}
                searchable={false}
                onChange={handleReportsChange}
                error={reportData.exportTypeStatus === "error" ? true : false}
                success={
                  reportData.exportTypeStatus === "success" ? true : false
                }
              />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
              <Box display="flex" gap={5} mt={3.4}>
                <AccessComponent name="Reports" action="Export" >
                <MaterialButton
                  variant="contained"
                  sx={{
                    background: colors.buttonColor,
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                  disabled={!isFormValid()}
                  onClick={onSubmitOpen}
                >
                  Export
                </MaterialButton>
                </AccessComponent>
                <AccessComponent name="Reports" action="Export" >
                <MaterialButton
                  onClick={resetForm}
                  variant="outlined"
                  color="error"
                >
                  Cancel
                </MaterialButton>
                </AccessComponent>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </DashboardLayout>
  );
}

export default Reports;
